import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { alphaValueValidator } from 'utilities/validators';
import { round5 as round } from 'utilities/math';

import CiAlphaFieldComponent from './Component';
import { recalculateCutoffs } from '../shared';

class CiAlphaFieldContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.handleChange = (_, newAlpha) => {
      if (newAlpha >= 1) {
        return this.props.recalculateCutoffs(0.99999);
      } else if (newAlpha <= 0) {
        return this.props.recalculateCutoffs(0.00001);
      }
      return this.props.recalculateCutoffs(newAlpha);
    };

    this.formatFn = value =>
      value || value === 0
        ? round(value)
        : '';

    this.normalizeValue = value => {
      if (value >= 1) {
        this.props.recalculateCutoffs(0.99999);
        return 0.99999;
      } else if (value <= 0) {
        this.props.recalculateCutoffs(0.00001);
        return 0.00001;
      }
      return round(value);
    };
  }

  render () {
    return (
      <Field
        name="alpha"
        type="number"
        max={0.99999}
        min={0.00001}
        step={0.00001}
        onChange={this.handleChange}
        format={this.formatFn}
        normalizeValue={this.normalizeValue}
        component={CiAlphaFieldComponent}
        validate={alphaValueValidator}
      />
    );
  }
}

CiAlphaFieldContainer.propTypes = {
  recalculateCutoffs: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  recalculateCutoffs
};

export default connect(null, mapDispatchToProps)(CiAlphaFieldContainer);
